var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',[_c('router-link',{attrs:{"to":{name:'PlanningHome'},"tag":"a"}},[_c('i',{staticClass:"fas fa-arrow-left"})]),_c('span',[_vm._v("Week Template")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }